var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui list"},_vm._l((_vm.value),function(item,index){return _c('div',{staticClass:"item"},[_c('a',{staticClass:"ui label"},[_vm._v(_vm._s(_vm.labelForItem(item)))])])}))}
var staticRenderFns = []

export { render, staticRenderFns }